export default __webpack_public_path__ + "static/media/239.227b7f53.png";